export const BRAND = {
  navy:    '#211747',
  purple:  '#512D6D',
  magenta: '#BB16A3',
  pink:    '#FF3EB5',
  light:   '#E5E1E6',
  error:   '#FF4D4F',
  ok:      '#3BB273',
  warn:    '#FF8C00',
};
